import { useModal } from 'hooks/useModal';
import ChatBubble from 'svg/ChatBubble';
import Pencil from 'svg/Pencil';
import PlusPlain from 'svg/PlusPlain';
import { Button } from 'components/Button';
import type { VenueFaq } from '../../types';
import EditFaqModal from './EditFaqModal';
import FaqItem from './FaqItem';

interface Props {
  faqs: VenueFaq[];
  /** Called after a successful save so the overview can refetch the venue. */
  onUpdated: () => void;
}

export default function ClubFaq({ faqs, onUpdated }: Props) {
  const { isOpen, openModal, closeModal } = useModal();
  const hasFaqs = faqs.length > 0;

  return (
    <section className="flex flex-col gap-6">
      <div className="flex items-center gap-4">
        <h2 className="typography-product-heading-compact-desktop text-color-text-lightmode-primary dark:text-color-text-darkmode-primary">
          FAQ
        </h2>
        {hasFaqs && (
          <Button
            variant="primary-light"
            size="icon"
            label="Edit FAQ"
            className="h-8 w-8 shadow-fab"
            onClick={() => openModal()}
          >
            <Pencil className="h-4 w-4" />
          </Button>
        )}
      </div>

      {hasFaqs ? (
        <div className="flex flex-col gap-6">
          {faqs.map((entry) => (
            <FaqItem key={entry.id} entry={entry} />
          ))}
        </div>
      ) : (
        <div className="flex flex-col items-center gap-3 rounded-2xl border border-dashed border-color-border-input-lightmode py-10 text-center dark:border-color-border-input-darkmode">
          <ChatBubble className="h-8 w-8 text-color-text-lightmode-icon dark:text-color-text-darkmode-icon" />
          <div className="flex flex-col gap-1">
            <p className="typography-product-subheading text-color-text-lightmode-primary dark:text-color-text-darkmode-primary">
              No FAQs yet
            </p>
            <p className="typography-product-body max-w-xs text-color-text-lightmode-secondary dark:text-color-text-darkmode-secondary">
              Add the questions players most often ask about your club.
            </p>
          </div>
          <Button
            variant="secondary"
            size="md"
            isInline
            iconLeft={<PlusPlain className="h-4 w-4" />}
            onClick={() => openModal()}
          >
            Add FAQ
          </Button>
        </div>
      )}

      <EditFaqModal
        isOpen={isOpen}
        handleClose={closeModal}
        initialFaqs={faqs}
        onSaved={onUpdated}
      />
    </section>
  );
}
